<template>
  <CommonPageShell
    :title="text.create.page.title"
    :subtitle="text.create.page.subtitle"
    :actions="headerActions"
    @action="onHeaderAction"
  >
    <template #content>
      <section class="invoice-create-page">
        <PaymentReceiptCreateTopSection
          :text="text"
          :payments-text="paymentsText"
          :customer-options="filteredCustomerOptions"
          :selected-customer="selectedCustomer"
          :contributor-options="contributorOptions"
          :selected-receiver="selectedReceiver"
          :tax-regime-options="taxRegimeOptions"
          :cfdi-use-options="cfdiUseOptions"
          :payment-method-type-options="paymentMethodTypeOptions"
          :payment-form-options="paymentFormOptions"
          :payment-account-options="paymentAccountOptions"
          :info="info"
          :currency="currency"
          :exchange-rate="exchangeRate"
          :customer-pending-amount="customerPendingAmount"
          :bank-details="bankDetails"
          :document-type-options="documentTypeOptions"
          @select-customer="selectCustomer"
          @select-receiver="selectReceiver"
          @info-change="onInfoChange"
          @update:bank-details="onBankDetailsChange"
          @update:currency="onCurrencyChange"
          @update:exchange-rate="onExchangeRateChange"
          @edit-contributor="onEditContributor"
        />

        <PaymentReceiptCreateApplicationSection
          :text="text"
          :documents="applicationDocuments"
          :loading="loadingPendingDocuments"
          :voucher-type="info.voucherType"
          :currency="currency"
          :received-amount="Number(info.receivedAmount || 0)"
          :payment-method-type-options="paymentMethodTypeOptions"
          @update-application="onApplicationAmountChange"
          @toggle-liquidate="onToggleApplicationLiquidate"
        />

        <PaymentReceiptCreateBottomSection
          :total="appliedTotalAmount"
          :currency="currency"
        />

        <PaymentReceiptCreateFooterActions
          :submitting="submitting"
          :disable-cfdi="disableSubmitCfdi"
          :show-cfdi="String(info.voucherType || '').trim().toLowerCase() !== 'simple_note'"
          @submit="submitPayment"
          @submit-cfdi="submitPaymentCfdi"
        />

        <PaymentReceiptCreateConfirmSubmitModal
          :show="showSubmitConfirmModal"
          :text="text"
          :mode="submitConfirmMode"
          :voucher-type="info.voucherType"
          :submitting="submitting"
          :customer-name="submitSummary.customerName"
          :voucher-type-label="submitSummary.voucherTypeLabel"
          :payment-info="submitSummary.paymentInfo"
          :fiscal-info="submitSummary.paymentInfo.fiscalInfo"
          :items="submitSummary.items"
          :total-amount="submitSummary.totalAmount"
          :currency="currency"
          :exchange-rate="exchangeRate"
          @close="closeSubmitConfirmation"
          @confirm="confirmSubmitPayment"
        />
      </section>
    </template>
  </CommonPageShell>
</template>

<script>
import CommonPageShell from '@/components/common/CommonPageShell.vue';
import PaymentReceiptCreateTopSection from '@/components/paymentReceipts/create/PaymentReceiptCreateTopSection.vue';
import PaymentReceiptCreateApplicationSection from '@/components/paymentReceipts/create/PaymentReceiptCreateApplicationSection.vue';
import PaymentReceiptCreateBottomSection from '@/components/paymentReceipts/create/PaymentReceiptCreateBottomSection.vue';
import PaymentReceiptCreateFooterActions from '@/components/paymentReceipts/create/PaymentReceiptCreateFooterActions.vue';
import PaymentReceiptCreateConfirmSubmitModal from '@/components/paymentReceipts/create/PaymentReceiptCreateConfirmSubmitModal.vue';
import { useDomainText } from '@/composables/text/useDomainText';
import {
  createPaymentReceiptCreateState,
  paymentReceiptCreateComputed,
  paymentReceiptCreateMethods,
} from '@/composables/paymentReceipts/usePaymentReceiptCreatePage';

const { catalog: paymentReceiptsText } = useDomainText('paymentReceipts');
const { catalog: paymentsText } = useDomainText('payments');

export default {
  name: 'PaymentReceiptCreatePage',
  components: {
    CommonPageShell,
    PaymentReceiptCreateTopSection,
    PaymentReceiptCreateApplicationSection,
    PaymentReceiptCreateBottomSection,
    PaymentReceiptCreateFooterActions,
    PaymentReceiptCreateConfirmSubmitModal,
  },
  data() {
    return {
      text: paymentReceiptsText,
      paymentsText,
      ...createPaymentReceiptCreateState(paymentReceiptsText),
    };
  },
  created() {
    this.initializePage();
  },
  computed: paymentReceiptCreateComputed,
  methods: paymentReceiptCreateMethods,
};
</script>
